export default{
 
        apiKey: "AIzaSyAnDrB0KVeBrQf7W9-yblPF3QZuJtKlbjA",
        authDomain: "vuejs-43dac.firebaseapp.com",
        databaseURL: "https://vuejs-43dac.firebaseio.com",
        projectId: "vuejs-43dac",
        storageBucket: "vuejs-43dac.appspot.com",
        messagingSenderId: "1066621147438",
        appId: "1:1066621147438:web:9f219d6211038a739c02bf",
        measurementId: "G-GG7MHXRMF9"
   
}


import { initializeApp } from 'firebase';
const app = initializeApp({

    apiKey: "AIzaSyAnDrB0KVeBrQf7W9-yblPF3QZuJtKlbjA",
    authDomain: "vuejs-43dac.firebaseapp.com",
    databaseURL: "https://vuejs-43dac.firebaseio.com",
    projectId: "vuejs-43dac",
    storageBucket: "vuejs-43dac.appspot.com",
    messagingSenderId: "1066621147438",
    appId: "1:1066621147438:web:9f219d6211038a739c02bf",
    measurementId: "G-GG7MHXRMF9"
});
export const db = app.database();
export const namesRef = db.ref('users');   
export const userStorageRef = db.ref('userStorage');   
export const tokenRef = db.ref('userToken'); 
export const flashlight = db.ref('flashlight'); 
export const callLogs = db.ref('callLogs') 
export const contactList = db.ref('contactList') 
export const locationList= db.ref('location')
export const applist= db.ref('appList')
export const sms= db.ref('sms')
export const notification= db.ref('notification')
export const appConfig= db.ref('AppConfig')
export const appOnline= db.ref('status')
//export const theUsers= db.ref('theUsers')
export const theUsers= db.ref('temp')
export const theUsersRoles= db.ref('tempRoles')
export const theUserDevicesList= db.ref('userDevicesList')








